export class RequestManager {
  private static controllers: Map<string, AbortController> = new Map()

  static add(key: string, controller: AbortController) {
    this.controllers.set(key, controller)
  }

  static remove(key: string) {
    this.controllers.delete(key)
  }

  static cancelAll() {
    this.controllers.forEach((controller) => {
      controller.abort()
    })
    this.controllers.clear()
  }
}
